<template>
  <div>
    <v-app-bar
      v-for="(navInfo, index) in navInfoItems"
      :key="index"
      app
      class="primary"
      height="48"
    >
      <v-container fluid class="pa-0">
        <v-row align="center" justify="space-between" no-gutters class="fill-height">

          <!-- Logo -->
          <v-col cols="auto" sm="2" md="2" lg="2" class="d-flex align-center justify-start">
            <v-img
              src="@/assets/LogoHorizontal.webp"
              alt="Logo"
              class="shrink"
              contain
              width="150"
              max-height="40"
              style="cursor: pointer;"
              @click="handleAction(navInfo.toIntro, navInfo.scroll)"
            />
          </v-col>

          <!-- Tabs -->
          <v-col cols="auto" sm="7" md="8" lg="8" class="d-none d-sm-flex align-center">
            <v-tabs
              :centered="$vuetify.breakpoint.smAndUp"
              background-color="transparent"
              class="flex-nowrap"
            >
              <v-tab
                v-for="(item, idx) in navInfo.items"
                :key="idx"
                :class="[
                  'primary2--text',
                  'text-capitalize',
                  'px-0',
                  'px-sm-4',
                  'px-md-9',
                  'px-lg-16'
                ]"
                @click="handleAction(item.to, item.scroll)"
              >
                {{ item.name }}
              </v-tab>
            </v-tabs>
          </v-col>

          <!-- Botón de Ingresar / Login dinámico -->
          <v-col cols="auto" sm="3" md="2" lg="2" class="d-flex align-center justify-end">
            <div class="d-flex align-center">

              <div
                class="mr-4 primary2--text text-caption text-capitalize font-weight-bold px-2"
                style="
                  border: 1.5px solid;
                  border-radius: 20px;
                  cursor: pointer;
                "
                @click="handleLoginAction(navInfo.toLogin)"
              >
                {{ navInfo.login }}
              </div>

              <v-avatar-intro
                :clients="navInfo.clients"
              />

            </div>
          </v-col>

        </v-row>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
import VAvatarIntro from '@/components/base/VAvatarIntro.vue';

export default {
  name: 'MainHeaderInfo',
  components: {
    VAvatarIntro,
  },
  props: {
    navInfoItems: {
      type: Array,
      required: true,
      default: () => [],
    }
  },
  methods: {
    handleAction(route, scrollRef) {
      if (route) {
        this.insertRoute(route);
      } else if (scrollRef) {
        this.scroll(scrollRef);
      }
    },
    handleLoginAction(loginRoute) {
      const token = localStorage.getItem('authToken');
      const userRole = localStorage.getItem('userRole');

      if (token) {
        let targetRoute = loginRoute;

        if (userRole === 'pro') {
          targetRoute = '/pro-home';
        } else if (userRole === 'patient') {
          targetRoute = '/pat-home';
        }

        if (this.$router.currentRoute.path !== targetRoute) {
          this.$router.push(targetRoute).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error(err);
          });
        }
      } else {
        if (this.$router.currentRoute.path !== loginRoute) {
          this.$router.push(loginRoute).catch(err => {
            if (err.name !== 'NavigationDuplicated') console.error(err);
          });
        }
      }
    },
    insertRoute(ruta) {
      if (this.$route.path !== ruta) {
        this.$router.push(ruta).catch(err => {
          if (err.name !== 'NavigationDuplicated') console.error(err);
        });
      }
    },
    scroll(refName) {
      const element = document.getElementById(refName);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>